import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AddNewProgramFormModel } from '../../../AddNewProgram.types'
import { FieldSection } from '../../../formSection/fieldSection/FieldSection'

import { Checkbox } from '@percent/lemonade'

// On or off, nothing more: `checkGroups: {}` asks for the default set, and departures from it are
// set on the configuration directly. The form holds the whole entry so a duplicate keeps them.
export function FraudCheck() {
  const { t } = useTranslation()

  const { setValue, control } = useFormContext<AddNewProgramFormModel>()

  const [fraudCheck, identityChecks, associationChecks] = useWatch({
    control,
    name: ['fraudCheck', 'identityChecks', 'associationChecks']
  })

  const isFraudCheckDisabled = !identityChecks?.length && !associationChecks?.length

  useEffect(() => {
    if (isFraudCheckDisabled) {
      setValue('fraudCheck', undefined)
    }
  }, [isFraudCheckDisabled, setValue])

  return (
    <FieldSection subSection>
      <Checkbox
        variant="default"
        active={!!fraudCheck}
        name="fraudCheck"
        label={t('form.fraudCheck')}
        disabled={isFraudCheckDisabled}
        onChange={event => {
          const isChecked = (event as React.ChangeEvent<HTMLInputElement>).target.checked

          setValue('fraudCheck', isChecked ? { type: 'fraud_check', checkGroups: {} } : undefined)
        }}
      />
    </FieldSection>
  )
}
